export const appendVersions = (toolbar_link) => {
    if (toolbar_link && document.body.hasAttribute('data-project_version')) {
        const span1 = document.createElement('span')
        const span2 = document.createElement('span')
        const span3 = document.createElement('span')
        span1.classList.add('versions', 'project-version')
        span3.classList.add('versions', 'deployment-version')
        span1.title = 'Project version.'
        span3.title = 'Deployment version.'
        const project_version = document.body.dataset.project_version ? document.body.dataset.project_version : '...'
        const deployment_version =
            document.body.dataset.deployment_version ? document.body.dataset.deployment_version : '...'
        span1.appendChild(document.createTextNode(project_version))
        span2.appendChild(document.createTextNode('/'))
        span3.appendChild(document.createTextNode(deployment_version))
        span4.appendChild(document.createTextNode(platform_node))
        toolbar_link.after(span1, span2, span3, span4)
    }
}
